import { Box, Text, dimensions } from '@factorialco/deprecated-design-system'

export const PropContainer = ({ children }: { children: React.ReactNode }) => (
  <Box
    style={{ display: 'inline-block', marginBottom: dimensions.s6 }}
    borderRadius={{ all: 'abs008' }}
    border={{ all: { width: 's1', style: 'solid', color: 'grey400' } }}
    paddingY="s2"
    paddingX="s6"
  >
    <Text.Normal size="200" weight="medium" color="grey1000">
      {children}
    </Text.Normal>
  </Box>
)
